import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableComponent } from 'components/table/table.component';
import { API_USER_NOTIFICATION, ApiService } from 'services/api.service';
import { AuthorizationService } from 'services/authorization.service';
import { FilterType, TableColumn } from 'types/table-column.interface';
import { NotificationStatus } from 'types/user.interface';

@Component({
  selector: 'app-notifications-page',
  standalone: true,
  imports: [TranslateModule, TableComponent],
  templateUrl: './notifications-page.component.html',
  styleUrl: './notifications-page.component.scss'
})
export class NotificationsPageComponent implements OnInit {
  @ViewChild('notificationTable') notificationTable!: TableComponent;

  apiNotificationsPath!: string;

  notificationColumns: TableColumn[] = [
    {
      name: 'pages.workspace.tableColumns.status',
      key: 'isRead',
      multiselectFilterName: 'isRead',
      styleClass: 'status-column status-width',
      sortEnabled: true,
      sortKey: 'isRead',
      valueTranslate: 'pages.workspace.tableColumns.notificationStatus.',
      filter: FilterType.MultiSelect,
      filterOptions: Object.values(NotificationStatus),
      tooltipText: 'notificationStatus'
    },
    {
      name: 'pages.workspace.tableColumns.createdOn',
      key: 'createdOn',
      sortKey: 'createdOn',
      filter: FilterType.DateTime,
      styleClass: 'dateTime-width',
      type: 'dateTime',
      sortEnabled: true
    },
    {
      name: 'pages.workspace.tableColumns.notificationText',
      key: 'text',
      tooltipText: 'notificationText',
      renderInnerHtml: true
    }
  ];

  constructor(
    private authService: AuthorizationService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    const userId = this.authService.getUserId();
    this.apiNotificationsPath = `${API_USER_NOTIFICATION}/user/${userId}`;
  }
}
